import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';

export const DetailColumnFormat = (value, row, rowIndex, { onOrderOTDay }) => {
	return (
		<>
			<EyeIcon onClick={() => onOrderOTDay(value)} color="primary" />
		</>
	);
};
